exports.connect = {
	url: "https://api.camping-la-tuquette.camp/"
}
